import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import NavBarProfil from "../../components/NavBarProfil/NavBarProfil";
import "./Adresses.scss";
import CardAdressses from "../../components/CardAdresses/CardAdresses";
import Cookies from "js-cookie";
import {Loader} from "../../utils/Loader";
import AccountActiveOrNot from "../../components/AccountActiveOrNot/AccountActiveOrNot";
import TextAccountNotActiveWithDeconnectButton
    from "../../components/AccountActiveOrNot/TextAccountNotActiveWithDeconnectButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMapLocationDot } from "@fortawesome/free-solid-svg-icons";

function Adresses() {
    const navigate = useNavigate();
    const [isDataLoading, setDataLoading] = useState(false);
    const [adresses, setAdresses] = useState([]);
    const [accountActive, setAccountActive] = useState(null);

    const tableauObjet = Object.values(adresses || {});
    const [btnAddAdresseClique, setbtnAddAdresseClique] = useState(false);

    useEffect(() => {
        document.title = "Mes adresses";
        const fetchAllAdresses = async () => {
            setDataLoading(true);
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}adresses`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${Cookies.get("auth_token")}`,
                    },
                });
                if (response.ok) {
                    const data = await response.json();
                    setAdresses(data);
                }
            } catch (error) {
                console.log(error);
            } finally {
                setDataLoading(false);
            }
        };
        fetchAllAdresses();
    }, []);

    useEffect(() => {
        if (btnAddAdresseClique) {
            navigate("/profil/adresses/ajoutAdresse");
        }
    }, [btnAddAdresseClique, navigate]);

    return (
        <>
            <AccountActiveOrNot setAccountActive={setAccountActive}/>
            {accountActive === false && accountActive !== null ? (
                <TextAccountNotActiveWithDeconnectButton/>
            ) : (
                <div className="div-main-page-adresses">
                    <NavBarProfil></NavBarProfil>
                    <div className={"div-container-right"}>
                        <div className="client-orders-header">
                            <div className="header-text">
                                <h1>Mes adresses</h1>
                                <p>Gérez vos adresses de livraison et de facturation.</p>
                            </div>
                            <button className="btn-add-adress" onClick={() => setbtnAddAdresseClique(true)}>
                                <FontAwesomeIcon icon={faPlus} />
                                Ajouter une adresse
                            </button>
                        </div>
                        
                        {isDataLoading ? (
                            <Loader></Loader> 
                        ) : adresses.length > 0 ? (
                            <div className="adresses-grid">
                                {tableauObjet.map((adresse) => (
                                    <CardAdressses
                                        key={adresse._id}
                                        adresseId={adresse._id}
                                        nomPersonne={adresse.nomPersonne}
                                        prenomPersonne={adresse.prenomPersonne}
                                        adresse={adresse.adresse}
                                        codePostal={adresse.codePostal}
                                        pays={adresse.pays}
                                        ville={adresse.ville}
                                        complementAdresse={adresse.complementAdresse}
                                        numTel={adresse.numTel}
                                        setAdresses={setAdresses}
                                        adresses={adresses}
                                    />
                                ))}
                            </div>
                        ) : (
                            <div className="empty-orders">
                                <FontAwesomeIcon icon={faMapLocationDot} style={{ fontSize: "4rem", color: "#cbd5e1", marginBottom: "1rem" }} />
                                <h3>Aucune adresse pour le moment</h3>
                                <p>Ajoutez une adresse pour faciliter vos prochaines commandes.</p>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </>
    );
}

export default Adresses;
